const extraRootUrl = 'https://kswd-hfls-site.s3-us-west-1.amazonaws.com/extras/downloads/';


export default [
  {
    grade: 'Kindergarten',
    items: [
      {
        label: 'Flash Cards',
        // extraText: 'for helping your students',
        url: extraRootUrl + 'GK - Flash Cards.pdf',
      },
      {
        label: 'Games and Activities',
        url: extraRootUrl + 'GK - Games and Activities.pdf',

      },
    ],
  },
  {
    grade: 'First Grade',
    items: [
      {
        label: 'Flash Cards',
        // extraText: 'for helping your students',
        url: extraRootUrl + 'G1 - Flash Cards.pdf',
      },
      {
        label: 'Games and Activities',
        url: extraRootUrl + 'G1 - Games and Activities.pdf',

      },
    ],
  },
  {
    grade: 'Second Grade',
    items: [
      {
        label: 'Flash Cards',
        // extraText: 'for helping your students',
        url: extraRootUrl + 'G2 - Flash Cards.pdf',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/ForTeachers/Extra/extra.data.js